import { useState } from 'react'
import { useForm } from 'react-hook-form'
import useQuery from 'hooks/useQuery'
import { filterEmptyValues } from 'utils/helpers'
import { Button, Dropdown, TextInput } from 'components/common'
import { CustomObject } from 'types/common'
import { FILTER_FIELD_FOC_ORDERS, FOC_FORM_FIELDS } from './utils'
import StoreDropdown from 'components/userManagement/storeDropdown'
import { DateTime } from 'components/common/input/dateTime'

const {
  ORDER_NO,
  APPLIES_TO_MAGENTO_ORDER_NO,
  BARCODE_NO,
  LOCATION_CODE,
  ERP_ORDER_SYNC,
} = FOC_FORM_FIELDS

type Props = {
  toggleFilterForm: () => void
}

const FocOrderFilterForm = ({ toggleFilterForm }: Props) => {
  const { getQuery, removeQuery, setMultipleQueries } = useQuery()
  const filters = getQuery(FILTER_FIELD_FOC_ORDERS)

  const [resetFilter, setResetFilter] = useState(false)

  const { register, handleSubmit, setValue, reset } = useForm({
    defaultValues: filters,
  })

  const onFilterApply = (data: CustomObject) => {
    if (data?.[LOCATION_CODE.key] === 'NONE') {
      delete data[LOCATION_CODE.key]
    }

    if (data?.[ERP_ORDER_SYNC.key] === 'NONE') {
      delete data[ERP_ORDER_SYNC.key]
    }

    const filteredData = filterEmptyValues(data)

    if (Object.values(filteredData).length > 0) {
      setMultipleQueries({ [FILTER_FIELD_FOC_ORDERS]: filteredData, page: 1 })
    } else {
      removeQuery(FILTER_FIELD_FOC_ORDERS)
    }

    toggleFilterForm()
  }

  const cancelFilter = () => {
    reset(filters)
    setResetFilter((pre) => !pre)
    toggleFilterForm()
  }

  return (
    <div className="mt-2 rounded-lg border bg-white px-5 py-3 ">
      <div className="mx-auto max-w-5xl">
        <form onSubmit={handleSubmit(onFilterApply)}>
          <div className="grid grid-cols-2 gap-x-14 gap-y-3 md:grid-cols-3">
            {/* ORDER_NO */}
            <TextInput
              register={register}
              name={ORDER_NO.key}
              label={ORDER_NO.label}
            />

            {/* Invoice  */}
            <TextInput
              register={register}
              name={APPLIES_TO_MAGENTO_ORDER_NO.key}
              label={APPLIES_TO_MAGENTO_ORDER_NO.label}
            />

            {/* Area */}
            <TextInput
              register={register}
              name={BARCODE_NO.key}
              label={BARCODE_NO.label}
            />

            {/* Store */}
            <StoreDropdown
              withNoneOption
              setValue={setValue}
              defaultValue={filters?.[LOCATION_CODE.key] || resetFilter}
              name={LOCATION_CODE.key}
              label={LOCATION_CODE.label}
            />

            {/* ERP Sync */}
            <Dropdown
              name={ERP_ORDER_SYNC.key}
              label={ERP_ORDER_SYNC.label}
              setValue={setValue}
              defaultValue={filters?.[ERP_ORDER_SYNC.key] || resetFilter}
              options={[
                { label: '--- NONE ---', value: 'NONE', disabled: false },
                { label: 'Yes', value: 'true', disabled: false },
                {
                  label: 'No',
                  value: 'false',
                  disabled: false,
                },
              ]}
            />

            <DateTime label={'Orders From'} name={'from'} register={register} />

            <DateTime label={'Orders To'} name={'to'} register={register} />
          </div>
          <div className="my-4 flex gap-5">
            <Button buttonText="Apply Filters" className="w-32" />

            <Button
              buttonText="cancel"
              variant="outline"
              type="button"
              onClick={cancelFilter}
              className="w-32"
            />
          </div>
        </form>
      </div>
    </div>
  )
}

export default FocOrderFilterForm
